import React, { useEffect } from 'react';
import { string, bool } from 'prop-types';

const propTypes = {
  region: string.isRequired,
  portalId: string.isRequired,
  formId: string.isRequired,
  sfdcCampaignId: string.isRequired,
  isDark: bool,
};

const defaultProps = {
  isDark: false,
};

const Hubspot = ({ region, portalId, formId, sfdcCampaignId, isDark }) => {
  const target = 'hubspot-form';

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/v2.js';
    script.async = true;
    script.onload = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region,
          portalId,
          formId,
          sfdcCampaignId,
          target: `#${target}`,
        });
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [region, portalId, formId, sfdcCampaignId, target]);

  return (
    <div
      className={isDark ? 'c-hubspot c-hubspot-dark text-dark' : 'c-hubspot'}
      id={target}
    />
  );
};

Hubspot.propTypes = propTypes;
Hubspot.defaultProps = defaultProps;

export default Hubspot;
